const INIT_FORM = 'INIT_FORM';
const UPDATE_FORM = 'UPDATE_FORM';
const SET_FORM_ERROR = 'SET_FORM_ERROR';

export {
	INIT_FORM,
	UPDATE_FORM,
	SET_FORM_ERROR
};
